import { Box, Checkbox, FormControlLabel } from "@mui/material"
import { prevent } from "lib/prevent"
import { BlockClicks } from "lib/@components/block-clicks"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useRetiredSelection } from "routes/schedule/my-schedules/my-custom-schedules/retired-selection"

export function RetiredSelectCheckbox() {
    const { target } = useBoundContext()
    const [, toggle, isSelected] = useRetiredSelection()
    const checked = isSelected(target._id)

    return (
        <BlockClicks>
            <Box className="selected-box menu-pad">
                <FormControlLabel
                    label=""
                    control={
                        <Checkbox
                            className={`checkbox ${checked ? "checked" : "not-checked"}`}
                            checked={checked}
                            onClick={prevent(() => toggle(target._id))}
                            data-cy="retired-selected-checkbox"
                        />
                    }
                />
            </Box>
        </BlockClicks>
    )
}
